import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingVertical: 8,
    borderBottomWidth: 0.5,
    borderColor: '#dbdbdb'
  },
  rowDirection: {
    flexDirection: 'row',
    paddingHorizontal: 20
  },
  subjectTitle: {
    color: 'grey',
    fontSize: 9,
    marginHorizontal: 3
  },
  subjectValue: {
    color: 'black',
    fontSize: 9
  },
  imageContianer: {
    width: 30,
    height: 30,
    borderRadius: 15
  },
  image: {
    flex: 1
  }
})
export default styles
